import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import { useEffect } from 'react';
import classes from './styles.module.scss';
import { CircularProgress } from '@mui/material';

export interface PanelProps {
    id?: string; 
    title: string;
    children: any;
    loading?: boolean;
    onInit?: () => void;
    className?: string;
}

const Panel = (props: PanelProps) => {

    const { id, title, children, loading, onInit, className } = props;

    useEffect(() => {
        if (onInit)
            onInit();
    }, []);

    return (
        <div id={id} className="collapsable-panel">
            <Card variant="outlined">
                <CardHeader
                    component='div'
                    className={`${className} ${classes.title}`}
                    title={
                        <Box display="flex" alignItems="center">
                            <h3 className={classes.titleText}>{title}</h3>
                            {loading !== undefined && loading &&
                                <CircularProgress
                                    size={20}
                                    thickness={6}
                                    color='inherit'
                                />}
                        </Box>}
                />
                <CardContent>
                    {children}
                </CardContent>
            </Card>
        </div>
    );
}
export default Panel;